// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3H9uR","block":"styles_block__FZG2g","wrapper":"styles_wrapper__1D9Qb","default":"styles_default___hixx"};